import React from 'react';
import PropTypes from 'prop-types';
import { Loader as LoadComp } from '@vds/loaders';

class Loader extends React.PureComponent {
  render() {
    return (
      <LoadComp {...this.props} />
     );
  }
}
Loader.defaultProps = {
    active:false,
    fullscreen:false,
    id:''
}
Loader.propTypes = {
    active:PropTypes.bool,
    fullscreen:PropTypes.bool,
    id:PropTypes.string
}
export default Loader;